import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { ElementsState } from '@blaze-runtime/engine-data-access';
import { CanvasElementId } from '@blaze-runtime/engine-domain';
import { ElementFormState } from '@blaze-shared/elements-domain';

import {
  FormlikeFieldValidityObservable,
  FormValidityService,
  mapValidationErrorsToMessages,
} from '../../../services/forms/runtime/public-api';
import {
  ComponentValidationData,
  ComponentValidationHandler,
  ConnectValidationConfig,
} from '../io-data.models';

@Injectable({ providedIn: 'root' })
export class FormLikeFieldValidationHandler implements ComponentValidationHandler {
  protected readonly formValidity = inject(FormValidityService);
  protected readonly store = inject(Store<ElementsState>);

  connectValidation(config: ConnectValidationConfig): Observable<void> {
    const formlikeFieldValidity$ = this.observeFieldValidity(config);

    return formlikeFieldValidity$.pipe(
      map((state) => {
        const formState: ElementFormState = {
          errors: state.submitted ? state.errors : {},
          messages: state.submitted ? mapValidationErrorsToMessages(state.errors) : {},
        };
        config.setComponentInput('formState', formState);
      }),
    );
  }
  getValidationData(_elementId: CanvasElementId): ComponentValidationData | undefined {
    return undefined;
  }

  protected observeFieldValidity({
    element,
    elementContext$,
  }: ConnectValidationConfig): FormlikeFieldValidityObservable {
    return this.formValidity.observeFormlikeFieldValidity(element, elementContext$);
  }
}
